import { default as pagination } from "./pagination";
import PaginationItem, {
  Ellipsis,
  First,
  Last,
  Next,
  Prev,
} from "./paginationItem";

export type { PaginationProps } from "./pagination";
export type { PaginationItemProps } from "./paginationItem";

const Pagination = Object.assign(pagination, {
  Item: PaginationItem,
  First: First,
  Prev: Prev,
  Next: Next,
  Last: Last,
  Ellipsis: Ellipsis,
});

export default Pagination;
